import { render, staticRenderFns } from "./TeacherSelector.vue?vue&type=template&id=2e28134e"
import script from "./TeacherSelector.vue?vue&type=script&lang=js"
export * from "./TeacherSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports